// 'use client';

// import { buildCDNImageUrl, PRODUCT_IMAGE_SIZE } from '@/lib/utils/command';
// import NextImage, { ImageProps } from 'next/image';
// import { useMemo, useState, useEffect, useRef } from 'react';

// interface ImageBlurProps extends ImageProps {
//   src: string;
//   size?: PRODUCT_IMAGE_SIZE;
//   local?: boolean;
// }

// const Image: React.FC<ImageBlurProps> = ({ src, size, local, ...props }) => {
//   const defaultImage =
//     'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjQwMCIgdmlld0JveD0iMCAwIDQwMCA0MDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSI0MDAiIGhlaWdodD0iNDAwIiBmaWxsPSIjRjJGMkYyIi8+CjxwYXRoIGQ9Ik0xMTkuODQzIDE3NS42NzZDMTE2LjcwMSAxODAuMDQzIDExNC44NTMgMTg1LjM5OSAxMTQuODUzIDE5MS4xODdDMTE0Ljg1MyAxOTYuOTc1IDExNi43MDEgMjAyLjMzMiAxMTkuODQzIDIwNi42OTlWMjUzLjgwNkgxMDEuOTY0VjE1Mi4xNDVIMTE5Ljg0M1YxNzUuNjc1VjE3NS42NzZaIiBmaWxsPSIjQ0FDQUNBIi8+CjxwYXRoIGQ9Ik0yMTEuMzYyIDE1Mi4xNDVIMTkzLjQ4M1YyMzAuMTQ0SDIxMS4zNjJWMTUyLjE0NVoiIGZpbGw9IiNDQUNBQ0EiLz4KPHBhdGggZD0iTTI0MS40NSAxNTIuMTQ1SDIyMy41NzFWMjMwLjE0NEgyNDEuNDVWMTUyLjE0NVoiIGZpbGw9IiNDQUNBQ0EiLz4KPHBhdGggZD0iTTE0My4zMTUgMTUyQzEyMS42NzEgMTUyIDEwNC4xMjcgMTY5LjU0NCAxMDQuMTI3IDE5MS4xODhDMTA0LjEyNyAyMTIuODMxIDEyMS42NzEgMjMwLjM3NSAxNDMuMzE1IDIzMC4zNzVDMTY0Ljk1OCAyMzAuMzc1IDE4Mi41MDIgMjEyLjgzMSAxODIuNTAyIDE5MS4xODhDMTgyLjUwMiAxNjkuNTQ0IDE2NC45NTggMTUyIDE0My4zMTUgMTUyWk0xNDEuNDUxIDIxNC4zNTlDMTI4LjY1MyAyMTQuMzU5IDExOC4yOCAyMDMuOTg0IDExOC4yOCAxOTEuMTg4QzExOC4yOCAxNzguMzkyIDEyOC42NTUgMTY4LjAxNyAxNDEuNDUxIDE2OC4wMTdDMTU0LjI0NyAxNjguMDE3IDE2NC42MjIgMTc4LjM5MiAxNjQuNjIyIDE5MS4xODhDMTY0LjYyMiAyMDMuOTg0IDE1NC4yNDcgMjE0LjM1OSAxNDEuNDUxIDIxNC4zNTlaIiBmaWxsPSIjQ0FDQUNBIi8+CjxwYXRoIGQ9Ik0xNDIuMjMyIDIwNS40ODRDMTUwLjEyNyAyMDUuNDg0IDE1Ni41MjggMTk5LjA4NCAxNTYuNTI4IDE5MS4xODhDMTU2LjUyOCAxODMuMjkyIDE1MC4xMjcgMTc2Ljg5MiAxNDIuMjMyIDE3Ni44OTJDMTM0LjMzNiAxNzYuODkyIDEyNy45MzUgMTgzLjI5MiAxMjcuOTM1IDE5MS4xODhDMTI3LjkzNSAxOTkuMDg0IDEzNC4zMzYgMjA1LjQ4NCAxNDIuMjMyIDIwNS40ODRaIiBmaWxsPSIjQ0FDQUNBIi8+CjxwYXRoIGQ9Ik0yMzMuMTY0IDE4NS45M0wyNzEuMjQ3IDE1Mi4xNDVIMjk2LjE0M0wyMzMuODU2IDIwOS4wNDlMMjMzLjE2NCAxODUuOTNaIiBmaWxsPSIjQ0FDQUNBIi8+CjxwYXRoIGQ9Ik0yNTcuNTM3IDE4MS43MjJMMjQ1LjI0OSAxOTQuOTYzTDI3My43MyAyMzAuMTQ1SDI5OC4wMzdMMjU3LjUzNyAxODEuNzIyWiIgZmlsbD0iI0NBQ0FDQSIvPgo8L3N2Zz4K';

//   const initialSrc = useMemo(() => {
//     return local ? src : buildCDNImageUrl(src, size ?? PRODUCT_IMAGE_SIZE.LARGE);
//   }, [src, size, local]);

//   const [initSrc, setInitSrc] = useState<string>(initialSrc);
//   const [isPriority, setIsPriority] = useState<boolean>(false);
//   // const [isLoading, setIsLoading] = useState(true);

//   const imgRef = useRef<HTMLImageElement>(null);
//   const hasRendered = useRef(false); // Track if the image has already been rendered

//   const handleError = () => {
//     setInitSrc(defaultImage);
//   };

//   useEffect(() => {
//     const imgElement = imgRef.current;
//     if (!imgElement || hasRendered.current) return;

//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             setIsPriority(true);
//             hasRendered.current = true; // Set the flag to true to prevent further renders
//             observer.disconnect();
//           }
//         });
//       },
//       {
//         rootMargin: '0px',
//         threshold: 0.1,
//       },
//     );

//     observer.observe(imgElement);

//     return () => {
//       observer.disconnect();
//     };
//   }, []);

//   return (
//     <>
//       <NextImage
//         ref={imgRef}
//         src={initSrc}
//         {...props}
//         alt={props.alt || 'Image'}
//         onError={handleError}
//         priority={isPriority}
//         quality={100}
//         // onLoad={() => setIsLoading(false)}
//       />
//     </>
//   );
// };

// export default Image;
// // 'use client';

// // import { buildCDNImageUrl, PRODUCT_IMAGE_SIZE } from '@/lib/utils/command';
// // import NextImage, { ImageProps } from 'next/image';
// // import { useState, useEffect } from 'react';

// // interface ImageBlurProps extends ImageProps {
// //   src: string;
// //   size?: PRODUCT_IMAGE_SIZE;
// //   local?: boolean;
// // }

// // const Image: React.FC<ImageBlurProps> = ({ src, size, local, ...props }) => {
// //   const [initSrc, setInitSrc] = useState<string>(() =>
// //     buildCDNImageUrl(src, size ?? PRODUCT_IMAGE_SIZE.LARGE),
// //   );

// //   const defaultImage =
// //     'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNc+BMAAkEBnO68DEUAAAAASUVORK5CYII=';

// //   useEffect(() => {
// //     if (local) {
// //       setInitSrc(src);
// //     } else {
// //       setInitSrc(buildCDNImageUrl(src, size ?? PRODUCT_IMAGE_SIZE.LARGE));
// //     }
// //   }, [src, size, local]);

// //   return (
// //     <NextImage
// //       src={initSrc}
// //       {...props}
// //       alt={props.alt}
// //       onError={() => setInitSrc(defaultImage)}
// //       loading={'lazy'}
// //     />
// //   );
// // };

// // export default Image;
'use client';

import { buildCDNImageUrl, PRODUCT_IMAGE_SIZE } from '@/lib/utils/command';
import NextImage, { ImageProps } from 'next/image';
import { useMemo, useState } from 'react';

interface ImageBlurProps extends ImageProps {
  src: string;
  size?: PRODUCT_IMAGE_SIZE;
  local?: boolean;
  placeholder?: 'blur' | 'empty';
}

const Image: React.FC<ImageBlurProps> = ({
  src,
  size = PRODUCT_IMAGE_SIZE.LARGE,
  local = false,
  placeholder = 'empty',
  ...props
}) => {
  // Default fallback image SVG
  const defaultImage =
    'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjQwMCIgdmlld0JveD0iMCAwIDQwMCA0MDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSI0MDAiIGhlaWdodD0iNDAwIiBmaWxsPSIjRjJGMkYyIi8+CjxwYXRoIGQ9Ik0xMTkuODQzIDE3NS42NzZDMTE2LjcwMSAxODAuMDQzIDExNC44NTMgMTg1LjM5OSAxMTQuODUzIDE5MS4xODdDMTE0Ljg1MyAxOTYuOTc1IDExNi43MDEgMjAyLjMzMiAxMTkuODQzIDIwNi42OTlWMjUzLjgwNkgxMDEuOTY0VjE1Mi4xNDVIMTE5Ljg0M1YxNzUuNjc1VjE3NS42NzZaIiBmaWxsPSIjQ0FDQUNBIi8+CjxwYXRoIGQ9Ik0yMTEuMzYyIDE1Mi4xNDVIMTkzLjQ4M1YyMzAuMTQ0SDIxMS4zNjJWMTUyLjE0NVoiIGZpbGw9IiNDQUNBQ0EiLz4KPHBhdGggZD0iTTI0MS40NSAxNTIuMTQ1SDIyMy41NzFWMjMwLjE0NEgyNDEuNDVWMTUyLjE0NVoiIGZpbGw9IiNDQUNBQ0EiLz4KPHBhdGggZD0iTTE0My4zMTUgMTUyQzEyMS42NzEgMTUyIDEwNC4xMjcgMTY5LjU0NCAxMDQuMTI3IDE5MS4xODhDMTA0LjEyNyAyMTIuODMxIDEyMS42NzEgMjMwLjM3NSAxNDMuMzE1IDIzMC4zNzVDMTY0Ljk1OCAyMzAuMzc1IDE4Mi41MDIgMjEyLjgzMSAxODIuNTAyIDE5MS4xODhDMTgyLjUwMiAxNjkuNTQ0IDE2NC45NTggMTUyIDE0My4zMTUgMTUyWk0xNDEuNDUxIDIxNC4zNTlDMTI4LjY1MyAyMTQuMzU5IDExOC4yOCAyMDMuOTg0IDExOC4yOCAxOTEuMTg4QzExOC4yOCAxNzguMzkyIDEyOC42NTUgMTY4LjAxNyAxNDEuNDUxIDE2OC4wMTdDMTU0LjI0NyAxNjguMDE3IDE2NC42MjIgMTc4LjM5MiAxNjQuNjIyIDE5MS4xODhDMTY0LjYyMiAyMDMuOTg0IDE1NC4yNDcgMjE0LjM1OSAxNDEuNDUxIDIxNC4zNTlaIiBmaWxsPSIjQ0FDQUNBIi8+CjxwYXRoIGQ9Ik0xNDIuMjMyIDIwNS40ODRDMTUwLjEyNyAyMDUuNDg0IDE1Ni41MjggMTk5LjA4NCAxNTYuNTI4IDE5MS4xODhDMTU2LjUyOCAxODMuMjkyIDE1MC4xMjcgMTc2Ljg5MiAxNDIuMjMyIDE3Ni44OTJDMTM0LjMzNiAxNzYuODkyIDEyNy45MzUgMTgzLjI5MiAxMjcuOTM1IDE5MS4xODhDMTI3LjkzNSAxOTkuMDg0IDEzNC4zMzYgMjA1LjQ4NCAxNDIuMjMyIDIwNS40ODRaIiBmaWxsPSIjQ0FDQUNBIi8+CjxwYXRoIGQ9Ik0yMzMuMTY0IDE4NS45M0wyNzEuMjQ3IDE1Mi4xNDVIMjk2LjE0M0wyMzMuODU2IDIwOS4wNDlMMjMzLjE2NCAxODUuOTNaIiBmaWxsPSIjQ0FDQUNBIi8+CjxwYXRoIGQ9Ik0yNTcuNTM3IDE4MS43MjJMMjQ1LjI0OSAxOTQuOTYzTDI3My43MyAyMzAuMTQ1SDI5OC4wMzdMMjU3LjUzNyAxODEuNzIyWiIgZmlsbD0iI0NBQ0FDQSIvPgo8L3N2Zz4K';

  // Calculate the image src
  const imageSrc = useMemo(() => {
    if (!src) return defaultImage;
    return local ? src : buildCDNImageUrl(src, size);
  }, [src, size, local]);

  // Track whether the image has loaded successfully
  const [imgSrc, setImgSrc] = useState<string>(imageSrc);

  // Handle image load errors
  const handleError = () => {
    setImgSrc(defaultImage);
  };

  // Calculate blurDataURL for placeholder if needed
  const blurDataURL = placeholder === 'blur' ? defaultImage : undefined;

  return (
    <NextImage
      src={imgSrc}
      {...props}
      alt={props.alt || 'Image'} // Ensure alt text for accessibility
      onError={handleError}
      loading="lazy"
      placeholder={placeholder}
      blurDataURL={blurDataURL}
    />
  );
};

export default Image;
